/*
 * @Author       : didi
 * @Date         : 2022/1/18 9:47 下午
 * @Description  : 车次列表相关接口
 */

import { mpx } from '@didi/es-mpx-creator'
import {
  QUERY_TRAIN_INFO,
  GET_TRAIN_LIST,
  GET_MULTI_TRAIN_LIST,
  TRAIN_INFO_BY_NO,
  AUTH,
  SERVICE_NOTICE,
  USER_REVERSE
} from '../urls'
import { trackingInfo } from '@/common/jump';

/**
 * @method 获取车次列表
 * @param data
 * @returns {Promise}
 */
export const getTrainList = data => {
  return mpx.$http.post(GET_TRAIN_LIST, { data })
}

/**
 * @method 获取抢票车次列表
 * @param data
 * @returns {Promise}
 */
export const getMultiTrainList = data => {
  return mpx.$http.post(GET_MULTI_TRAIN_LIST, { data })
}

/**
 * @method 车次列表授权
 * @param data
 * @returns {Promise}
 */
export const trainAuth = data => {
  return mpx.$http.post(AUTH, { data })
}

/**
 * @method 获取车次详情
 * @param data
 * @param data.train_date
 * @param data.from_station_name
 * @param data.to_station_name
 * @param data.train_no
 * @returns {Promise}
 */
export const getTrainDetail = data => {
  return mpx.$http.post(TRAIN_INFO_BY_NO, { data })
}

/**
 * @method 公告提示
 * @param params
 * @param params.source_service 业务线
 * @param params.from_city 出发城市id
 * @param params.to_city  到达城市id
 * @returns {Promise}
 */

export const loadServiceNotice = params => {
  return mpx.$http.get(SERVICE_NOTICE, { params })
}

/**
 * @method 获取时刻表
 * @param params
 * @returns {Promise}
 */
export const queryTrainInfo = data => {
  return mpx.$http.post(QUERY_TRAIN_INFO, { data })
}

/**
 * @method 预定登录态校验
 * @param params
 * @returns {Promise}
 */
export const getUserReverse = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(USER_REVERSE, { data: params });
}
